export const shouldPersistPreferenceDefault = (namespace, value) => (
  namespace !== 'viewer.hanging_protocols'
  || !Array.isArray(value)
  || value.length > 0
);
